import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BACKEND_URL } from '../../Constants';

function DashboardHome() {

  const userRole = localStorage.getItem('role');
  console.log('userRole',userRole)

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPublishedCourses = async () => {
      setLoading(true);
      setError(null);
      try {
        // Fetch only public and published courses from your backend
        const response = await axios.get(`${BACKEND_URL}/api/courses/public`);
        console.log(response.data);
        setCourses(response.data || []); // Ensure it's an array, even if empty
      } catch (err) {
        console.error('Error fetching published courses:', err);
        setError('Failed to load published courses. Please check the server connection.');
      } finally {
        setLoading(false);
      }
    };

    fetchPublishedCourses();
  }, []); // Empty dependency array means this runs once on component mount

  if (loading) {
    return (
      <div className="row pt-4 pb-2">
        <div className="col-12 text-center">
          <p className="text-muted">Loading published courses...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="row pt-4 pb-2">
        <div className="col-12">
          <div className="alert alert-danger" role="alert">
            Error: {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    {userRole && userRole === 'admin' && ( <>
    <div className="row pt-4 pb-2">
      <div className="col-12">
        <div className="row dashboard-card-courses">
          <div className="col-12 col-lg-3 order-lg-last">
            <div className='row'>
              <div className="col-12">
                <h2 className="page-title">To Do:</h2>
                <hr/>
                <ol className='ml-4'>
                  <li><Link to="/dashboard">Create To Do.</Link></li>
                </ol>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-9 order-lg-first">
            <h2 className="page-title">Published Courses</h2>
            <hr/>
            {courses.length === 0 ? (
                <div className="alert alert-info" role="alert">
                  No published courses available at this time.
                </div>
              ) : (
                <>
                <div className='row'>
                {
                  courses.map((course) => (
                    <div key={course._id} className="col-lg-4" style={{ '--course-color': course.color }}>
                      <div className="card card-primary">
                        <div className="card-body">
                          <h5 className="card-title text-primary">{course.title}</h5>
                          {course.description && (
                            <p className="card-text mb-1 text-truncate" style={{ maxWidth: '100%' }}>
                              {(() => {
                                try {
                                  const rawContent = JSON.parse(course.description);
                                  const plainText = rawContent.blocks.map(block => block.text).join(' ');
                                  return plainText.length > 150 ? plainText.substring(0, 150) + '...' : plainText;
                                } catch (e) {
                                  return course.description.length > 150 ? course.description.substring(0, 150) + '...' : course.description;
                                }
                              })()}
                            </p>
                          )}
                          <ul className="list-group list-group-flush list shadow-none mt-3 mb-3">
                            <li className="list-group-item d-flex justify-content-between align-items-center">License <span>{course.license}</span></li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">Active Students <span>0</span></li>
                            <li className="list-group-item d-flex justify-content-between align-items-center">Applicants <span>0</span></li>
                          </ul>
                          <Link
                            to={`/course/${course._id}`}
                            className="btn btn-inverse-primary waves-effect waves-light m-1"
                            target="_blank"
                          >
                            <i className="fa fa-globe mr-1"></i> View
                          </Link>
                          <Link
                            to={`/dashboard/courses/${course._id}`}
                            className="btn btn-primary waves-effect waves-light m-1"
                          >
                            <i className="fa fa-star mr-1"></i> Edit
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                }
                </div>

                </>
              )}
          </div>
        </div>
        </div>
      </div>

      </> )}

    </>
  );
}

export default DashboardHome;
